import React from 'react';
import { User } from 'lucide-react';
const HERO_BG = 'https://drwzpk38qkpfb.cloudfront.net/www.apc360zone.com/preview/uploaded/images/Redesigne%202024/Aboutbg.jpeg?opt=w3';
export function HeroSection() {
  return <section className="relative py-24 md:py-32 flex items-center border-b border-brand-gray-800 overflow-hidden" data-id="element-565">
      <img src={HERO_BG} alt="About" className="block absolute inset-0 w-full h-full object-cover object-top" data-id="element-566" />
      <div className="absolute inset-0 bg-gradient-to-b from-brand-black/50 via-brand-black/40 to-brand-black z-[1]" data-id="element-567" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 w-full text-center" data-id="element-568">
        <div className="inline-flex items-center gap-2 px-3 py-1 border border-brand-teal/30 bg-brand-teal/10 text-brand-teal text-xs font-bold uppercase tracking-widest mb-6" data-id="element-569">
          <User className="w-4 h-4" data-id="element-570" />
          Leadership
        </div>
        <h1 className="text-3xl md:text-5xl font-extrabold text-brand-white tracking-tight leading-tight mb-4 uppercase" data-id="element-571">
          Jose Medina
        </h1>
        <p className="text-lg md:text-xl text-brand-teal font-semibold mb-2" data-id="element-572">
          Chief Executive Officer, Awareness Protective Consultants, LLC
        </p>
        <p className="text-lg text-brand-gray-400" data-id="element-573">
          Retired 27-Year Law Enforcement Officer/Supervisor
        </p>
      </div>
    </section>;
}